import { Switch } from "@/components/ui/baseUi/switch"
import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"
import {
  type ExerciseFormikType,
  type ExerciseInputKey,
} from "@/modules/sessions/sessionForm/blocks/exerciseBlock/exerciseFormikTypes"
import { createExerciseScoreFormModel } from "@/modules/sessions/sessionForm/blocks/exerciseBlock/models/exerciseScoreFormModel"
import type { SimpleFormik } from "@/typings/formik"
import { word } from "@modules/core/utils/i18n"

export function ExerciseMediaRequirementInput({
  formik,
  className,
  ...props
}: { formik: SimpleFormik<ExerciseFormikType, ExerciseInputKey> } & React.ComponentProps<"div">) {
  const model = createExerciseScoreFormModel(formik.values.scoreSetConfigurations, formik.values.scoringOption)

  return (
    <div className={cn("rounded-2xl bg-surface-foreground px-5 py-6", className)} {...props}>
      {/* Media requirement */}
      <div className="flex flex-col gap-2">
        <Text className="text-textDefault-body" fontStyle="LS">
          {word("program.planning.create.exercise.media_requirement.title").toUpperCase()}
        </Text>

        <div className="flex w-full justify-between">
          <Text
            className={cn(
              "font-semibold text-textDefault-body",
              !model.canSetMediaRequirement && "text-textDisabled-on-color",
            )}
            fontStyle="LL"
          >
            {word("program.planning.create.exercise.media_requirement.label")}
          </Text>
          <Switch
            checked={formik.values.requiredMedia ?? false}
            onCheckedChange={(e: boolean) => {
              formik.setFieldValue("requiredMedia", e ?? false)
            }}
            disabled={!model.canSetMediaRequirement}
          />
        </div>

        <Text
          fontStyle="BS"
          className={cn("mt-1 text-textDefault-caption", !model.canSetMediaRequirement && "text-textDisabled-on-color")}
        >
          {word("program.planning.create.exercise.media_requirement.description")}
        </Text>
      </div>
    </div>
  )
}
